<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Errors from "../../Errors.svelte";
  import Label from "../Label.svelte";

  const dispatch = createEventDispatcher();

  export let errors: string[] = [];
  export let placeholder: string = "";
  export let disabled: boolean = false;
  export let required: boolean = false;
  export let small: boolean = false;
  export let value: string = "";
  export let name: string = "";
  //export let type: string = "text";
  export let maxlength: number = null;
  export let debounce: number = 700;

  let searchInputRef: any;

  const onDebounced = debounceDelay(sendDebouncedValue, debounce);

  $: displayName = required && name != "" ? name + " *" : name;

  function onKeyDown(event: KeyboardEvent) {
    if (event.keyCode == 13) {
      event.preventDefault();
      dispatch("enter", event);
    } else {
      dispatch("keydown", event);
    }
  }

  function onBlur(event: Event) {
    dispatch("blur", event);
  }

  function silentClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }

  function onKeyUp(_event: Event) {
    onDebounced();
  }

  function sendDebouncedValue() {
    dispatch("debounced", value);
  }

  function debounceDelay(cb: any, interval: number) {
    let timeout: any;

    return function () {
      let context = this,
        args = arguments;
      let later = function () {
        timeout = null;
        cb.apply(context, args);
      };

      clearTimeout(timeout);

      timeout = setTimeout(later, interval);
    };
  }
</script>

<div>
  {#if name != ""}
    <Label>
      {displayName}
    </Label>
  {/if}

  <input
    bind:this={searchInputRef}
    class="input"
    class:is-danger={required && value == ""}
    class:is-small={small}
    class:input-ctr-disabled={disabled}
    bind:value
    on:keydown={onKeyDown}
    on:keyup={onKeyUp}
    on:blur={onBlur}
    on:click={silentClick}
    {placeholder}
    {disabled}
    {required}
    type="text"
    {maxlength}
  />

  <Errors {errors} prefix={name} />
</div>

<style>
  .input-ctr-disabled {
    border-color: #dbdbdb;
  }
</style>
